import { useRef } from 'react';
import { useSiteMotion } from '../anim/useSiteMotion.ts';
import { Accountability } from '../components/Accountability.tsx';
import { Compatibility } from '../components/Compatibility.tsx';
import { Contact } from '../components/Contact.tsx';
import { Hero } from '../components/Hero.tsx';
import { Levels } from '../components/Levels.tsx';
import { Platform } from '../components/Platform.tsx';
import { Problem } from '../components/Problem.tsx';
import { Proof } from '../components/Proof.tsx';
import { SharedFloor } from '../components/SharedFloor.tsx';

export function Landing() {
  const page = useRef<HTMLElement>(null);
  useSiteMotion(page);

  return (
    <main id="top" ref={page}>
      <Hero />
      <Problem />
      <Platform />
      <SharedFloor />
      <Levels />
      <Compatibility />
      <Accountability />
      <Proof />
      <Contact />
    </main>
  );
}
